import { createAction } from "redux-act";

export const handleCreateJob = createAction("HANDLE_CREATE_JOB");
export const handleUpdateJob = createAction("HANDLE_UPDATE_JOB");
export const handleRemoveJob = createAction("HANDLE_REMOVE_JOB");
